import {
  JobCard,
  JobCardStartup,
  JobCardSpotlight,
  JobCardLight,
  JobCardSnow,
} from "@/ui/components";
import { THEME_TYPES } from "@lib/enums";

export const JOB_CARD_VARIANTS = [
  { type: THEME_TYPES.PROFESSIONAL, label: "Professional", Component: JobCard },
  { type: THEME_TYPES.STARTUP, label: "Startup", Component: JobCardStartup },
  { type: THEME_TYPES.SPOTLIGHT, label: "Spotlight", Component: JobCardSpotlight },
  { type: THEME_TYPES.LIGHT, label: "Light", Component: JobCardLight },
  { type: THEME_TYPES.SNOW, label: "Snow", Component: JobCardSnow },
];

export function getJobCardComponent(type) {
  const match = JOB_CARD_VARIANTS.find((v) => v.type === type);
  return match ? match.Component : JobCard;
}
